
import TradingBlockRemote from '../../services/TradingBlockRemote'
import {ErrorCodeMap} from '../../domain/TbMaps';

const state = () => ({
  loaded: false,
  loading: false,
  error: false,
  response: null
});

export default {
  namespaced: true,

  state,
  mutations:{
    setLoading(state){
      state.loading = true;
      state.error = null;
      state.loaded = false;
    },
    setLoaded(state, payload){
      state.loading = false;
      state.error = null;
      state.loaded = true;
      state.response = payload;
    },
    setError(state, payload){
      if (payload.status>0)
        this.error = ErrorCodeMap[status];
      else
        this.error ="Server or network error: "+ Math.abs(payload.status) + ". Please, report via email";

      state.loading = false;
      state.error = payload;
      state.loaded = false;
    }
  },
  actions:{
    async Load({state, commit}, payload){
      commit('setLoading');

      new TradingBlockRemote({
        onComplete: (resp)=>{
          if (!resp)
            commit('setError', "Balance fetch error  ");
          else
            commit('setLoaded', resp);
        },
        onFailure: ()=> {
          commit('setError', "Balance fetch error  ")
        }
      }).GetBalance();


    }
  },
}